import { render, staticRenderFns } from "./InputBlockBtn.vue?vue&type=template&id=2d776bf3&scoped=true&"
import script from "./InputBlockBtn.vue?vue&type=script&lang=js&"
export * from "./InputBlockBtn.vue?vue&type=script&lang=js&"
import style0 from "./InputBlockBtn.vue?vue&type=style&index=0&id=2d776bf3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d776bf3",
  null
  
)

export default component.exports